import { useEffect } from 'react';
import { useRouter } from 'next/router';
import { fetchMeData } from '@actions/helpCenter';
import { useFlagSelector } from '@hooks/useLayoutOptions';
import initializeFreshbots from '@utils/freshbotsInit';

const useFreshBots = (
  route,
  accessToken,
  showFreshbot,
  dispatch,
  me,
  isLoggedIn,
  isEducatorSide,
  selectedGoal,
  isClassModalOpened
) => {
  const router = useRouter();
  const { inside_app } = router.query;
  const hideFreshbot = useFlagSelector('hideFreshbot');

  useEffect(() => {
    if (!process.env.FRESHBOT_CLIENT_KEY && !process.env.FRESHBOT_HASH_KEY)
      return;
    if (!window.Freshbots && !hideFreshbot && showFreshbot && !inside_app) {
      if (!isLoggedIn || me.isEducator) return;

      const roles = { 1: 'learner', 2: 'educator' };
      dispatch(
        fetchMeData(isEducatorSide ? roles[2] : roles[1], me ? me.jwtToken : '')
      ).then((response) => {
        if (response) {
          initializeFreshbots(
            route,
            {
              accessToken,
              me,
              isLoggedIn,
              selectedGoal: selectedGoal?.uid
            },
            response.result
          );
          window.isFreshbotsVisible = true;
        }
      });
    }
    const interval = setInterval(() => {
      const freshBot = document.getElementById('mobile-chat-container');
      if (freshBot) {
        if (!hideFreshbot && isLoggedIn && !isClassModalOpened) {
          freshBot.style.display = 'block';
        } else {
          freshBot.style.display = 'none';
        }
        clearInterval(interval);
      }
      if (!window.Freshbots) {
        clearInterval(interval);
      }
    }, 1000);
    return () => {
      clearInterval(interval);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [route, isLoggedIn, isClassModalOpened]);
};

export default useFreshBots;
